import { AWUapTouAcknowledgement } from '@blk/awt-userpreference';
import { AGraphWrappedType, unwrapAGraphResponse } from '../../utils/AGraphWrapper';
import { userPreferenceApi } from './Base';
const path = '/v1/uap-tou-acknowledgements';

// DEPRECATED Follow-up Ticket: 3356986 Make ToU backward compatible with the old config.
/**
 * Retrieves the acknowledgments for the Terms of Use.
 *
 * @returns {Promise<AWUapTouAcknowledgement[]>} A promise that resolves to the acknowledgments data.
 */
export async function getUAPTermsOfUseAcknowledgments() {
  const response = await userPreferenceApi.get<AGraphWrappedType<AWUapTouAcknowledgement[], 'acknowledgements'>>(path);
  return unwrapAGraphResponse(response, 'acknowledgements');
}

/**
 * Sends a new acknowledgment to the user preference API.
 *
 * @param newAcknowledgement - The acknowledgment data to be posted.
 * @returns A promise that resolves with the posted acknowledgment data.
 */
export function postUAPTermsOfUseAcknowledgment(newAcknowledgement: AWUapTouAcknowledgement) {
  return userPreferenceApi.post<AWUapTouAcknowledgement>(path, newAcknowledgement);
}
